import React from "react"
import axios from "axios"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { useNavigate } from 'react-router-dom'
import * as Yup from "yup"


import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';

import styled from 'styled-components';

const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiTheatra = `${protocole}${host}:${port}`

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
`
const Champ = styled.div`
margin:10px auto;
padding: 0;
`


const PageLogin = () => {

    const userVide = {
        email:"",
        password:""
    }

    const navigate = useNavigate()

    const onSubmit = (elementCourant) => {
        //console.log("envoi formulaire")
        axios.post(`${apiTheatra}/auth/signin`, elementCourant)
          .then((res) => {
            //console.log("status " + res.status)
            switch(res.status){
                case 200:
                    //alert(elementCourant.email + " connecté");
                    //console.log(res.data)
                    localStorage.setItem("email", res.data.email)
                    localStorage.setItem("token-access", res.data.accessToken)
                    //console.log(res.headers)
                    var maDate = new Date();
                    maDate.setDate(maDate.getDate()+1);
                    localStorage.setItem("date_expired", maDate.toJSON())
                    navigate("/notice")
                    return
                case "404":
                    alert("Compte " + elementCourant.email + " inconnu");
                    return
                case 401:
                    alert("Mot de passe erroné");
                    //console.log(res.data)
                    return
                default:
                    console.log("Problème : " + res.status)
                    Promise.reject();
                    break
            }
          })
          .catch((err) => alert("Un problème est survenu lors de l'authentification " + err.message));
      }

    const FormulaireJSX = () => {
        return(<Form>
            <Champ>
                <label>Email</label>
                <Field name="email" type="text" size="20"/>
                <ErrorMessage name="email" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ>
                <label>Password</label>
                <Field name="password" type="password" size="20" autoComplete="on"/>
            </Champ>
            <button type="submit" onSubmit={onSubmit}>Se connecter</button>
            </Form>)
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Email incorrect').required('Required'),
      })


    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>Login</Title>
            <Formik
                initialValues={userVide}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}>
                <FormulaireJSX />
            </Formik>
            <Footer/>
        </Page>)
}
export default PageLogin